  // ********************** TextForm.js ********************

  import React, { useState } from "react";
  import PropTypes from "prop-types";

  export default function Textform(props) {
    const [text, setText] = useState("Input Text"); 

    const Uppercase = ()=> {

      console.log(" Converting the text into uppercase");

      let upText = text.toUpperCase(); // Converting to text into upperText and storing into new variable
      
      setText(upText); // Setting that variable to text and text will set the value in text area
      {props.showAlert("Text is converted to Upper Case", "success")};


    }


    // adding event in the argument, event that happen
    const ChangingText = (event)=> 
    {
      console.log("Changing text");
      setText(event.target.value); // This will add the written text ahead of already present value

    }
    
    const Lowercase = ()=> // Converting to LowerCase
    {
      console.log("Lowercase");
      let newText = text.toLowerCase();
      setText(newText);
      {props.showAlert("Text is converted to Lower Case", "success")};
    }
    
    const Clear = ()=> {

      setText("");
      {props.showAlert("Text is Cleared", "success")};

    }


    // Creating a map for Morse Code
    const morseCodeMapping = {
      A: ".-",
      B: "-...",
      C: "-.-.",
      D: "-..",
      E: ".",
      F: "..-.",
      G: "--.",
      H: "....",
      I: "..",
      J: ".---",
      K: "-.-",
      L: ".-..",
      M: "--",
      N: "-.",
      O: "---",
      P: ".--.",
      Q: "--.-",
      R: ".-.",
      S: "...",
      T: "-",
      U: "..-",
      V: "...-",
      W: ".--",
      X: "-..-",
      Y: "-.--",
      Z: "--..",
      ',':" ",
      '.':" ",
      

    };
    
    const MorseCode = ()=>{

      let textToConvert = text.toUpperCase();
      let MorseCodeText = "";
      
      for (let i = 0; i < textToConvert.length; i++) {
        let character = textToConvert[i];

        
        if(character === " ") 
        {
          MorseCodeText += " ";
        }
        else if (morseCodeMapping.hasOwnProperty(character)) 
        {
          MorseCodeText += morseCodeMapping[character] + " "; 
        }
        else 
        {
          MorseCodeText = " Invalid character ";
          {props.showAlert("Please type the valid characters", "danger")};

          break;
        }
        
      }

      setText(MorseCodeText);
      if(MorseCodeText !== " Invalid character ") {
        
        {props.showAlert("Text is converted to Morse Case", "success")};
      }

      

    }
    
    const NoOfWords = () => {
      let store = text.split( /\s+/ );
      // It will split by a white space and it also includes new line. we are using regular expressions here
      let len = store.length;
    
      let count = 0;
      for (let i = 0; i < len; i++) {
        if (store[i] === "" || store[i] === " ") {
          continue;
        } else {
          count++;
        }
      }
      return count;
    };
    



    return (
      <div>
        {/* Adding form from bootstrap. Class-> ClassName, for-> htmlFor*/}
        <div className=  "container mb-3" style= { {color: props.mode==="dark"?"white":"black"}}>
          {/* So here we are changing the color of texts of this container according the mode */}
          {/* Here we are chaning the color of the elements in the container according the mode */}
          <label htmlFor="myText" className="form-label">
            <h1>{props.heading}</h1>
            {/* taking heading as props */}
          </label>

          

          <textarea
            className="form-control"
            value={text}
            id="myText" // Id should be written in label
            rows="7" // We can change the size of textarea through rows
            onChange={ChangingText} // On change is an event that will be executed
            style = {{backgroundColor: props.mode==="light" ? "white" : "#cbced3", border: "2px solid black", color: props.mode==="dark"?"#4c4646":"black"}}
            // Here we are changing the background color of the textarea by using props
          ></textarea>

          
          <button type="button" disabled={text.length===0} className="btn btn-primary my-3 mx-1" onClick={Uppercase}> Change to Uppercase</button>
          <button type="button" disabled={text.length===0} className="btn btn-primary my-3 mx-1" onClick={Lowercase}> Change to Lowercase</button>
          {/* Creating a lowercase button here. Mx is used to set the margin in x axis */}
          <button type="button" disabled={text.length===0} className="btn btn-primary my-3 mx-1" onClick={MorseCode}> Convert to Morse Code</button>
          <button type="button" disabled={text.length===0} className="btn btn-primary my-3 mx-1" onClick={Clear}> Clear</button>
        {/* Adding disabled in button, if no words = 0 then the buttons will disable hence they wont perform any action if there are no words written so alert wont appear as well */}

          {/* Adding onClick event */}

          <h2 className="my-1">Your Text Summary</h2>
          <p>
            <strong>{text.length}</strong> Characters and <strong>{NoOfWords(text)}</strong> Words
            {/* Text Length gives the length of texts ie charcters. Text.split returns an array which have words in its indexes. Its .length function will give no of words */}
          </p>
          <p>
            <strong>{0.007 * NoOfWords(text)}</strong> Minutes read
            {/* It takes 0.007 minute to read one word */}
          </p>

          <h2>Preview</h2>
          <p>{text.length>0 ? text : "Nothing to preview"}</p> 
          {/* Prewing the text here */}


          <div className="container"></div>

        </div>

      </div>
    );
  }
